import { AUTH_TOP_BAR_HEIGHT_PX } from './loginLayoutConstants'
import { authTopBarBorder, surfaceAuthCard } from '@/theme/designTokens'

/** Figma 5074-11761 — full-width top chrome (1280×64 in handoff frame). Hidden on phones. */
export const authTopChromeSx = {
  flexShrink: 0,
  width: '100%',
  height: AUTH_TOP_BAR_HEIGHT_PX,
  minHeight: AUTH_TOP_BAR_HEIGHT_PX,
  maxHeight: AUTH_TOP_BAR_HEIGHT_PX,
  bgcolor: surfaceAuthCard,
  backgroundColor: surfaceAuthCard,
  borderBottom: `1px solid ${authTopBarBorder}`,
  boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.05)',
  boxSizing: 'border-box',
  position: 'relative',
  zIndex: 2,
} as const
